export default "__VITE_ASSET__DK_8qKek__"